import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box,
  Avatar 
} from '@mui/material';

const StatsCard = ({ title, value, change, icon, color = 'primary' }) => {
  // Determine color based on change value
  const changeColor = change.startsWith('+') ? 'success.main' : 'error.main';
  
  // Map color prop to actual color values
  const getAvatarColor = (color) => {
    switch(color) {
      case 'primary': return '#3f51b5';
      case 'secondary': return '#f50057';
      case 'success': return '#4caf50';
      case 'warning': return '#ff9800';
      case 'error': return '#f44336';
      case 'info': return '#2196f3';
      default: return '#3f51b5';
    }
  };
  
  return (
    <Card 
      className="stats-card" 
      sx={{ 
        height: '100%', 
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        borderRadius: 3,
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
        '&:hover': {
          boxShadow: '0 6px 12px rgba(0,0,0,0.08)',
        }
      }}
    >
      <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
        <Box display="flex" alignItems="flex-start">
          <Avatar 
            sx={{ 
              bgcolor: getAvatarColor(color), 
              width: 56, 
              height: 56,
              fontSize: '1.5rem',
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {typeof icon === 'string' ? icon : icon}
          </Avatar>
          <Box ml={2} flex={1}>
            <Typography 
              color="text.secondary" 
              variant="body2" 
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              {title}
            </Typography>
            <Typography 
              variant="h5" 
              component="div" 
              gutterBottom
              sx={{ fontWeight: 600 }}
            >
              {value}
            </Typography>
            <Typography 
              variant="body2" 
              color={changeColor}
              sx={{ 
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {change}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatsCard;